<div *ngIf="loaded">
  <form [formGroup]="messageForm" class="k-form" (ngSubmit)="onSubmit()">
    <div class="content-background">
      <div class="row mb-2">
        <div class="col-12 d-flex pl-0 pr-0">
          <i class="fas pr-3 pt-2" [ngClass]="{'fa-reply': !isAll, 'fa-reply-all': isAll}" aria-hidden="true"></i>
          <kendo-multiselect type="text" [data]="toUsersFiltered" valueField="id" textField="name" formControlName="to"
            role="combobox" attr.aria-label="{{'TO' | translate}}" [filterable]="true"
            (filterChange)="filterToUsers($event)" (close)="searchTerm=''" [itemDisabled]="itemDisabled"
            aria-expanded="false" aria-controls=".k-list-ul">
            <ng-template kendoComboBoxItemTemplate let-dataItem>
              <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
              </span>
            </ng-template>
          </kendo-multiselect>
        </div>
      </div>
      <div class="row align-items-start">
        <label class="k-form-field">
          <textarea #textBodyControl id="replyBody" kendoTextArea rows="3" formControlName="replyBody"
            style="min-width: 100%" [readonly]="savingMessage || isReplyLimitReached" [attr.maxlength]="effectiveMaxReplyLength || null">
          </textarea>
          <span>{{replyBody.value ? replyBody.value.length : 0}}/{{effectiveMaxReplyLength}}</span>
          <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="isReplyLimitReached">
            {{'MESSAGE-REPLY-LIMIT-REACHED' | translate}}
          </div>
          <div class="w-100 message-body-content" style="padding-top:10px;padding-left:12px;color:gray"
            [innerHTML]="body.value">
          </div>
        </label>
      </div>
    </div>
  </form>
  <!--Enable message attachments-->
  <span *ngIf="attachmentsEnabled">
    <kendo-upload class="d-none" [autoUpload]="false" [multiple]="true" (select)="onFileChanged($event)">
    </kendo-upload>
    <button kendoButton [primary]="true" type="button" (click)="selectAttachment()" [disabled]="savingMessage"
      style="position:absolute;bottom:20px;">
      {{'ADD-DOCUMENT' | translate}}<i class="far fa-plus"></i>
    </button>
  </span>
  <div class="row k-form" *ngIf="selectedFiles && selectedFiles.length > 0">
    <label class="k-form-field file-list w-100">
      <div class="col-sm-12">
        <div class="row mt-1" *ngFor="let f of selectedFiles">
          <div class="col-sm-11">
            <i class="fas fa-file fa-lg" class="fa {{getFileTypeClass(f.type)}}" title="{{f.name}}"></i>
            {{f.name}}
          </div>
          <div class="col-sm-1 pointer" style="max-width:40px;position:absolute;right:0px">
            <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}" (click)="deleteAttachment(f.name)"
              role="button" attr.aria-label="{{ 'DELETE' | translate }}" tabindex="0"
              (keydown.enter)="deleteAttachment(f.name)" (keydown.space)="deleteAttachment(f.name)">
            </i>
          </div>
        </div>
      </div>
    </label>
  </div>
</div>